<template>
  <a-layout style="padding-top: 65px;">

    <a-layout-content :style="{ background: '#fff', padding: '24px', margin: 0, minHeight: '280px' }">

      <!-- 文章统计 -->
      <div>
        <the-statistic-article></the-statistic-article>
      </div>

    </a-layout-content>

    <!-- 底部 -->
    <TheFooter></TheFooter>

  </a-layout>


</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import axios from 'axios';
import { message } from 'ant-design-vue';
import { Tool } from "@/util/tool";
import TheStatisticArticle from '@/components/the-statistic-article.vue';
import TheFooter from "@/components/the-footer.vue";

// declare let hexMd5: any;
// declare let KEY: any;

export default defineComponent({
  name: 'AdminStatistic',
  components: {
    TheStatisticArticle,
    TheFooter
  },
  setup() {

    onMounted(() => {

    });

    return {

    }
  }
});
</script>

<style scoped>
/* img {
  width: 50px;
  height: 50px;
} */
</style>
